var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.686,
    height: 16,
    viewBox: "0 0 15.686 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10183",
    "data-name": "Grupo 10183",
    transform: "translate(-1224.157 -127.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10182",
    "data-name": "Grupo 10182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_12244",
    "data-name": "Caminho 12244",
    d: "M1235.085,136.744a6.015,6.015,0,1,0-1.85,1.7l4.436,4.41a1.259,1.259,0,1,0,1.826-1.734c-.015-.016-.03-.031-.046-.046Zm-4.914.411a3.88,3.88,0,1,1,3.878-3.887,3.879,3.879,0,0,1-3.878,3.887Z",
    fill: "#415364"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.9d506d87049fe14a78c25e2f30e86048.svg";
export { ForwardRef as ReactComponent };